<template>
	<div class="hello">
		<div class="bg">

			<div class="footer" style="background: rgba(247, 247, 247, 1);">
				<div class="content" ref="conten" @scroll="getscroll">
					<div class="contentList_img" v-if="content == ''">
						<img v-if="lang == 'cn'" src="../assets/image/wu.png" alt="">
						<img v-else src="../assets/image/wuE.png" alt="">
					</div>
					<div v-else class="contentList" v-html="content">
					</div>
				</div>
			</div>
			<div class="footerTitle">
				<div class="title_center">
					<div class="listB" style="padding-top: 4px;padding-bottom: 4px;">
						<a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 59px;'><img src='../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a>
					</div>
					<div class="listB">
						<span>{{$t('language.address_b')}}：{{info.address}}</span>
					</div>
					<div class="listB">
						<span>{{$t('language.emails')}}:{{info.email}}</span>
					</div>
					<div class="listB">
						<a href="https://beian.miit.gov.cn/" style="color: rgba(0, 0, 0, .7);text-decoration: none;">
						  <span>ICP备：晋ICP备18006634号-1</span>
						</a>
					</div>
				</div>
			</div>
			<fiex :shows="fiexd" :fatherMethod="goTop"></fiex>
		</div>
	</div>
</template>

<script>
	import fiex from '../components/fiex.vue'
	export default {
		data() {
			return {
				imageUrl: require('../assets/image/banner1.png'),
				image: require('../assets/image/news.png'),
				content: '',
				title: '',
				fiexd: false,
				lang: 'cn',
				info:{}
			}
		},
		components: {
			fiex
		},
		created() {
			if (localStorage.getItem('languageSet') == 'zh') {
				this.lang = 'en'
			} else {
				this.lang = 'cn'
			}
			this.$fetch('/Content/getSchedule').then(res => {
				this.content = res.data.info;
			})

			this.$fetch('/index/info').then(res => {
			  this.info = res.data;
			})
			// var data = {
			//   id:this.$route.query.id
			// }
			// this.$fetch('/news/detail',data).then(res=>{
			//     console.log(res)
			//     this.content = res.data.content;
			//     this.title = res.data.title;
			// })
		},
		methods: {
			goTop() {
				this.$refs.conten.scrollTop = 0;
			},
			getscroll() {
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || this.$refs.conten
					.scrollTop ||
					window.pageYOffset;
				if (scrollTop > 20) {
					this.fiexd = true;
				} else {
					this.fiexd = false;
				}
			}
		}
	}
</script>

<style scoped="scoped">
	@import url("../assets/css/newsDetails.css");
</style>



// WEBPACK FOOTER //
// src/pages/schedule.vue